import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/**
 * Aviso "varias lecturas" (solo se muestra si hay 2+ items en carrito)
 * Requiere un elemento en el drawer con: data-multi-reading-notice
 */
document.addEventListener('DOMContentLoaded', () => {
  const notice = document.querySelector('[data-multi-reading-notice]');
  const cartCount = document.querySelector('.cart-bubble__text');

  if (!notice || !cartCount) return;

  const updateNotice = () => {
    const count = parseInt((cartCount.textContent || '0').trim(), 10);
    notice.style.display = count > 1 ? 'block' : 'none';
  };

  updateNotice();

  // Si tu tema no dispara 'cart:updated', esto no rompe nada, solo no hace nada.
  document.addEventListener('cart:updated', updateNotice);
});
